export default __webpack_public_path__ + "static/media/BobDeclaration.8c93aa82.png";